import axiosInstance from '../axios';
import endpoints from '../endpoints';

const analyticsService = {
  /**
   * Get global analytics (Super Admin only)
   * Returns system-wide statistics across all contests
   */
  getGlobalAnalytics: async () => {
    const response = await axiosInstance.get(endpoints.analytics.global);
    return response.data;
  },

  /**
   * Get contest analytics
   * Returns detailed analytics for a specific contest
   */
  getContestAnalytics: async (contestId) => {
    const response = await axiosInstance.get(endpoints.analytics.contestAnalytics(contestId));
    return response.data;
  },

  /**
   * Get daily analytics for a contest
   */
  getDailyAnalytics: async (contestId, date = null) => {
    const queryParams = date ? `?date=${date}` : '';
    const response = await axiosInstance.get(`${endpoints.analytics.dailyAnalytics(contestId)}${queryParams}`);
    return response.data;
  },

  /**
   * Get payment analytics for a contest
   */
  getPaymentAnalytics: async (contestId) => {
    const response = await axiosInstance.get(endpoints.analytics.paymentAnalytics(contestId));
    return response.data;
  },

  /**
   * Get voter history for a contest
   */
  getVoterHistory: async (contestId) => {
    const response = await axiosInstance.get(endpoints.analytics.voterHistory(contestId));
    return response.data;
  },

  /**
   * Get voter statistics for a contest
   */
  getVoterStatistics: async (contestId) => {
    const response = await axiosInstance.get(endpoints.analytics.voterStatistics(contestId));
    return response.data;
  }
};

export default analyticsService;